import { render } from "./TopicListItem.vue?vue&type=template&id=7f742cab&scoped=true&ts=true"
import script from "./TopicListItem.vue?vue&type=script&lang=ts"
export * from "./TopicListItem.vue?vue&type=script&lang=ts"

import "./TopicListItem.vue?vue&type=style&index=0&id=7f742cab&scoped=true&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f742cab"]])

export default __exports__